<template>
  <div
    :style="{
      ...containerStyle,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    }"
  >
    <!-- สำหรับทำ BG -->
    <div
      :style="{
        ...containerBgStyle,
        position: 'absolute',
        zIndex: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundPositionX: 'center',
      }"
    ></div>

    <!-- Float -->
    <!-- Top -->
    <FloatTop
      v-if="isShowFloatTop"
      pageName="MicrositeBill"
      :campaign="campaign"
      :isShowRedirectHome="isShowFloatTop"
    />
    <!-- Bottom -->
    <FloatBottom pageName="MicrositeBill" :campaign="campaign" />

    <Survey
      v-if="survey"
      :survey="survey"
      style="height: fit-content; z-index: 1"
      :style="{
        paddingTop: isShowFloatTop ? '52px' : '0px',
      }"
    ></Survey>

    <v-dialog v-model="dialogConsent" width="500" persistent>
      <v-card data-testid="modal-consent">
        <v-btn
          fab
          @click="scrollToBottom"
          style="position: absolute; right: 6px; bottom: 10px; z-index: 1"
          color="grey darken-2"
          small
          v-if="showScrollIcon"
          class="mx-2"
        >
          <v-icon color="white" size="24">mdi-arrow-down </v-icon>
        </v-btn>

        <v-card-text
          @scroll="handleScroll"
          ref="scrollContainer"
          style="max-height: 90vh; overflow-y: auto"
        >
          <div class="pt-3">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="primary"
              fixed-tabs
              height="56px"
            >
              <v-tab
                href="#tab-1"
                v-if="campaign.is_show_policy"
                @click="
                  acceptConsent = false;
                  disabledTerms = true;
                "
              >
                <span v-html="$t('microsite.privacyPolicy')"></span>
              </v-tab>
              <v-tab
                href="#tab-2"
                v-if="campaign.is_show_terms"
                :disabled="disabledTerms"
              >
                <span v-html="$t('microsite.termAndCondition')"></span>
              </v-tab>

              <v-tabs-items v-model="tab" class="mt-5">
                <v-tab-item :value="'tab-1'">
                  <div
                    class="div-term-cond ql-editor"
                    v-html="formatHtmlDetail(campaign.policy_text)"
                  ></div>
                </v-tab-item>
                <v-tab-item :value="'tab-2'">
                  <div
                    class="div-term-cond ql-editor"
                    v-html="formatHtmlDetail(campaign.terms_text)"
                  ></div>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </div>
          <div ref="scrollTarget" class="text-end">
            <v-btn
              v-if="acceptConsent == false"
              data-testid="btn-next"
              :color="accentColor"
              text
              outlined
              class="px-4"
              style="border-radius: 8px"
              @click="acceptPdPa()"
            >
              {{ $t("microsite.textNext") }}
            </v-btn>

            <v-btn
              v-if="acceptConsent == true"
              data-testid="btn-accept"
              :color="accentColor"
              class="px-4"
              style="border-radius: 8px"
              :style="{
                color: getFontColorBasedOnBg(accentColor),
              }"
              @click="dialogConsent = false"
            >
              {{ $t("microsite.acceptConsent") }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-footer padless v-if="campaign.is_show_footer">
      <v-col class="text-center footer" cols="12">
        <p class="ql-editor" v-html="campaign.footer_text"></p>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Model } from "survey-core";
import { Survey } from "survey-vue-ui";
import "survey-vue/defaultV2.min.css";
import MicrositeAxios from "@/config/microsite-service";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
  customThemeSurveyJS,
  formatHtmlDetailDefault,
  formattedForSave,
  getFontColorBasedOnBg,
  transformJsonCustomInputMask,
} from "../../../config/general-function";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";
import FloatTop from "./components/float-top.vue";
import FloatBottom from "./components/float-bottom.vue";

export default {
  name: "MicrositeBill",
  inject: ["isAppLoading"],
  components: {
    Survey,
    FloatTop,
    FloatBottom,
  },
  data: () => ({
    campaign: {
      is_show_policy: false,
      policy_text: "",
      is_show_terms: false,
      terms_text: "",
      is_show_footer: false,
    },
    survey: null,
    surveyJson: null,
    header: null,
    consent: false,
    policy: false,
    dialogConsent: false,
    tab: "tab-1",
    themeName: null,
    containerStyle: {
      background: "#FFFFFF",
    },
    containerBgStyle: {
      background: "#FFFFFF",
    },
    acceptConsent: false,
    showScrollIcon: false,
    disabledTerms: false,
    accentColor: "blue",

    isHoverableDevice: false,
    activeFloat: null,
    secondClick: false,
  }),
  async created() {
    await this.getCampaign();
    this.onInit();
    this.getSurveyAndTheme();
    this.themeName = this.campaign.template.name;

    this.surveyJson = this.setQuestionAddress(this.surveyJson);
    this.surveyJson = this.setQuestionBrandBranch(this.surveyJson);
    this.surveyJson = transformJsonCustomInputMask(this.surveyJson);
    this.survey = new Model(this.surveyJson);
    this.survey.applyTheme(this.themeJson);
    this.survey.showCompletedPage = false;

    if (this.campaign.is_show_policy == 1 || this.campaign.is_show_terms == 1) {
      this.dialogConsent = true;
    }

    this.disabledField();
    this.handleUploadImage();
    this.handleSubmit();
    this.onValueChanged();
    this.onAfterRenderPage();
    this.onAfterRenderQuestion();
    this.checkMaxUpload();
    // ========== ========== ========== ==========
  },
  computed: {
    ...mapState("microsite", ["user"]),
    ...mapState("defaultSystem", ["site"]),
    isShowFloatTop() {
      let check = false;
      const token = localStorage.getItem("token");
      const is_sync_customer = this.campaign?.is_sync_customer;
      if (token && is_sync_customer) {
        check = true;
      }
      return check;
    },
  },
  methods: {
    acceptPdPa() {
      this.showScrollIcon = false;
      this.acceptConsent = true;
      this.disabledTerms = false;
      this.tab = "tab-2";
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;
        if (el) {
          el.scrollTop = 0; // Scroll to the top of the container
        }
      });
    },
    handleScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;

      const threshold = 20;
      setTimeout(() => {
        const bottom =
          el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

        this.showScrollIcon = !bottom && !el.scrollTop == 0;
      }, 100);
    },
    scrollToBottom() {
      if (!this.$refs.scrollContainer) return;
      this.$refs.scrollContainer.scrollTo({
        top: this.$refs.scrollContainer.scrollHeight,
        behavior: "smooth",
      });
    },
    onInit() {
      if (!this.campaign?.policy_text) {
        this.campaign.policy_text = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
          "microsite.dataNotFound"
        )}</div>`;
      }
      if (!this.campaign?.terms_text) {
        this.campaign.terms_text = `<div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">${this.$t(
          "microsite.dataNotFound"
        )}</div>`;
      }
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    async getCampaign() {
      try {
        const response = await MicrositeAxios.get(
          `getCampaign/${this.site.id}?slug=${this.$route.params.slug}`
        );

        this.campaign = response.data.data.microsite;
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "microsite-error",
          params: { slug: this.$route.params.slug },
        });
      }
    },
    getSurveyAndTheme() {
      const surveyJson = JSON.parse(this.campaign.survey_json);
      if (surveyJson && surveyJson.login) {
        let loginJson = surveyJson.login;
        this.header = loginJson["elements"][0];
      }
      if (surveyJson && surveyJson.bill) {
        this.surveyJson = surveyJson.bill;
      } else {
        this.surveyJson = JSON.parse(
          this.campaign.template.default_survey_json
        ).bill;
      }
      if (Array.isArray(this.surveyJson?.elements)) {
        for (let item of this.surveyJson.elements) {
          if (item.type == "file" && item.storeDataAsText == undefined) {
            item.storeDataAsText = false;
          }
        }
      }

      this.containerStyle = {
        backgroundColor: "#F3F3F3",
      };
      this.containerBgStyle = {
        backgroundColor: "#F3F3F3",
      };
      const themeJson = JSON.parse(this.campaign.theme_json);
      if (themeJson) {
        if (themeJson?.cssVariables) {
          const themeList = Object.keys(themeJson?.cssVariables);
          const _bg = themeList.find((x) => x == "--sjs-general-backcolor-dim");
          if (_bg) {
            this.containerStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            this.containerBgStyle = {
              backgroundColor: themeJson?.cssVariables[_bg],
            };
            if (themeJson?.backgroundImage) {
              this.containerBgStyle = {
                ...this.containerBgStyle,
                backgroundImage: `url(${themeJson.backgroundImage}`,
                backgroundSize: themeJson.backgroundImageFit,
                backgroundAttachment: themeJson.backgroundImageAttachment,
                opacity: themeJson.backgroundOpacity,
              };
              themeJson.backgroundImage = null;
              themeJson.cssVariables["--sjs-general-backcolor-dim"] =
                "transperent";
            }
          }
          const _accent = themeList.find((x) => x == "--sjs-primary-backcolor");
          if (_accent) {
            this.accentColor =
              themeJson?.cssVariables[_accent] || this.accentColor;
          }
        }
        customThemeSurveyJS(themeJson?.cssVariables);
        this.themeJson = themeJson;
      }
    },
    getFontColorBasedOnBg(bg_color) {
      const color = getFontColorBasedOnBg(bg_color, "bw");
      return color;
    },
    disabledField() {
      let phone = this.survey.getQuestionByName("phone");
      let fullname = this.survey.getQuestionByName("fullname");

      // disabled phone field
      // this.survey.getQuestionByName("phone").readOnly = true;
      if (this.user && this.user.phone && phone != null) {
        this.survey.setValue("phone", this.user.phone);
      }

      // disabled fullname field if user already registered
      if (this.user && this.user.fullname && fullname != null) {
        {
          this.survey.getQuestionByName("fullname").readOnly = true;
          this.survey.setValue("fullname", this.user.fullname);
        }
      }

      if (this.user && this.user.status_consent == 1) {
        this.dialogConsent = false;
      }
    },
    handleUploadImage() {
      this.survey.onUploadFiles.add(async (_, options) => {
        // ========== ========== ========== ==========
        const fileLimitMB = 40;
        if (Array.isArray(options.files) && options.files.length > 0) {
          let checkSize = false;
          for (let item of options.files) {
            if (item?.size / 1000000 > fileLimitMB) {
              checkSize = true;
              break;
            }
          }
          if (checkSize) {
            options.callback("error");
            const errText = this.$t("microsite.maxFileSizeAllowed", {
              size: fileLimitMB,
            });
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2500,
            });
            Toast.fire({
              icon: "error",
              title: errText,
            });
            return;
          }
        }
        // ========== ========== ========== ==========
        const getParam = () => {
          return {
            site_id: this.site.id,
            campaign_id: this.campaign.id,
          };
        };
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);
          const { site_id, campaign_id } = getParam();

          MicrositeAxios.post(
            `uploadImageTransaction/${site_id}?campaign=${campaign_id}`,
            formData
          )
            .then(({ data }) => {
              if (data.status == "success") {
                options.callback("success", [
                  {
                    file: file,
                    content: data.data?.url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== Brand Branch ========== ==========
        const branch_brand_first_questions =
          questions.find((x) => ["branch", "brand"].includes(x.name))?.name ||
          "";
        if (name == branch_brand_first_questions) {
          const second_question =
            branch_brand_first_questions == "branch" ? "brand" : "branch";
          const second = this.survey.getQuestionByName(second_question);
          if (second) {
            let is_same_page = true;
            const first = this.survey.getQuestionByName(
              branch_brand_first_questions
            );
            if (first.page.name != second.page.name) {
              is_same_page = false;
            }
            let list = [];
            let visible = false;
            if (value) {
              visible = true;
              const brands_branches = this.campaign?.brands_branches || [];
              const choice = brands_branches
                .filter(
                  (x) =>
                    x[`${branch_brand_first_questions}_name`] == value &&
                    x[`${second_question}_name`]
                )
                .map((x) => x[`${second_question}_name`]);
              const grouped = Object.groupBy(choice, (item) => item);
              console.log(grouped);
              list = Object.keys(grouped);
            }
            second.visible = visible;
            if (list.length == 0) {
              second.visible = false;
            }
            second.choices = list;
            // ========== ========== ========== ==========
            if (is_same_page) {
              _isAppLoading(true);
              const page = second.page;
              page.removeElement(second);
              setTimeout(() => {
                const _first = this.survey.getQuestionByName(
                  branch_brand_first_questions
                );
                const _page = _first.page;
                const originalIndex = _page.elements.indexOf(_first);
                this.survey.setValue(second_question, null);
                _page.addElement(second, originalIndex + 1);
                _isAppLoading(false);
              }, 100);
            }
          }
        }
        // ========== ========== ========== ==========
      });
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    setQuestionBrandBranch(schema) {
      let pages = schema?.pages || [];
      const brands_branches = this.campaign?.brands_branches || [];
      let first_question = "";
      let second_question = "";
      let flat_question = [];
      let is_same_page = true;
      const setBrandBranch = (elements) => {
        second_question = first_question == "branch" ? "brand" : "branch";
        if (Array.isArray(elements)) {
          const first = elements.find((x) => x.name == first_question);
          if (first) {
            const first_choice = brands_branches
              .filter((x) => x[`${first_question}_name`])
              .map((x) => x[`${first_question}_name`]);
            const grouped = Object.groupBy(first_choice, (item) => item);
            first.choices = Object.keys(grouped);
          }
          // ========== ========== ========== ==========
          const second = elements.find((x) => x.name == second_question);
          if (second && is_same_page) {
            second.visible = false;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let element = item.elements.map((x) => {
            return {
              ...x,
              page: item.name,
            };
          });
          if (Array.isArray(element)) {
            flat_question = [...flat_question, ...element];
          }
        }
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        const branch = flat_question.find((x) => ["branch"].includes(x.name));
        const brand = flat_question.find((x) => ["brand"].includes(x.name));
        if (branch && brand) {
          if (branch.page != brand.page) {
            is_same_page = false;
          }
        }
        if (first_question) {
          for (let item of pages) {
            let elements = item?.elements || [];
            elements = setBrandBranch(elements);
            if (item) {
              item.elements = elements;
            }
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        flat_question = [...elements];
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        elements = setBrandBranch(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    handleSubmit() {
      this.survey.onComplete.add(async () => {
        await this.onSubmit();
      });
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        if (["image_confirm"].includes(options.question.name)) {
          const element = options.htmlElement;
          element.style.cursor = "pointer"; // Optional: Change cursor to indicate clickable
          element.onclick = () => {
            if (options.question.name == "image_confirm") {
              const isSurveyHasErrors = this.survey.hasErrors();
              if (isSurveyHasErrors) return;
              this.onSubmit();
            }
          };
        }
      });
    },
    async onSubmit() {
      this.isAppLoading(true);
      try {
        // ========== ========== ========== ==========
        const formatJson = formattedForSave(
          this.survey.jsonObj,
          this.survey.data
        );
        // ========== ========== ========== ==========
        await MicrositeAxios.post(`submitTransactionBill/${this.campaign.id}`, {
          phone: this.user.phone,
          fullname:
            formatJson.fullname != undefined ? formatJson.fullname : null,
          amount: formatJson.amount != undefined ? formatJson.amount : null,
          orderId: formatJson.orderId != undefined ? formatJson.orderId : null,
          surveyResponseJson: JSON.stringify(formatJson),
        }).then((res) => {
          const dataResponse = res?.data?.data;
          if (dataResponse) {
            setTimeout(() => {
              this.$router.push({ name: "microsite-thankyou" });
            }, 1000);
          } else {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("microsite.errSubmissionFailed"),
                showConfirmButton: false,
                timer: 1500,
              })
              .then(() => {
                this.$router.go(0);
              });
          }
        });
      } catch (error) {
        this.$swal
          .fire({
            icon: "error",
            text: error.response.data.message,
            showConfirmButton: true,
          })
          .then(() => {
            this.$router.push({ name: "microsite-menu" });
          });
        console.log(error);
      }
      this.isAppLoading(false);
    },
    checkMaxUpload() {
      this.survey.onValidateQuestion.add((sender, options) => {
        const value = options.value;
        const question = options.question;
        const type = question?.getType();
        if (type == "file") {
          const maxUpload = question?.maxUpload || question?.jsonObj?.maxUpload;
          if (value?.length > maxUpload) {
            options.error = this.$t("microsite.maxFilesAllowed", {
              count: maxUpload,
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .footer p {
  word-break: break-all;
  margin-bottom: 0px !important;
}
::v-deep .v-footer {
  margin-top: auto !important;
  margin-bottom: 0px !important;
}

/* default */
::v-deep .sd-body--empty {
  display: none;
}
::v-deep .sd-body.sd-body--static {
  padding-top: 0px !important;
}
::v-deep .sd-page {
  padding: 0px !important;
}
::v-deep #sv-nav-complete {
  width: 100%;
}
::v-deep .sd-navigation__complete-btn {
  width: 100%;
}
::v-deep .sd-html span {
  font-size: inherit; /* ใช้ขนาดตาม h1 */
  font-weight: inherit; /* ใช้น้ำหนักตัวอักษรตาม h1 */
}
::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}
::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}

/* ในกรณีที่มี Component Panel */
::v-deep .sd-panel .sd-row:first-of-type {
  width: 100% !important;
  margin-left: 0px !important;
}
::v-deep .sd-panel .sd-row--multiple > div:first-of-type {
  padding-left: 0px !important;
}
</style>

<style lang="scss" scoped>
::v-deep .sd-file__decorator {
  background-color: var(
    --sjs-editorpanel-backcolor,
    var(
      --sjs-editor-background,
      var(
        --sjs-general-backcolor-dim-light,
        var(--background-dim-light, #f9f9f9)
      )
    )
  );
  border-radius: var(
    --sjs-editorpanel-cornerRadius,
    var(--sjs-corner-radius, 4px)
  );
}
::v-deep .sd-row:first-of-type {
  width: calc(100% + (2 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px))))));
  margin-left: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
  margin-right: calc(-1 * (3 * (var(--sjs-base-unit, var(--base-unit, 8px)))));
}
::v-deep .sd-row:first-of-type :is(.sd-image__image:first-of-type) {
  border-radius: 0px;
}
.table-show {
  max-width: calc(90 * (var(--sjs-base-unit, var(--base-unit, 8px))));
}
</style>
